import {Button, Statistic} from 'antd';
import classNames from 'classnames';
import {useEffect, useRef, useState} from 'react';
import {useRouter} from 'next/router';
import useCommon from '@utils/hooks/common';
import Poker from '@components/Poker';
import {PokerComponent, PokerInsuranceComponent} from '@interface';
import styles from './styles';
import PokerInsurance from '@components/PokerInsurance';

interface InsurancePokerInterface extends PokerComponent {
  onClick?: (pokerCard: PokerInsuranceComponent) => void;
}

const InsurancePoker = (props: InsurancePokerInterface): JSX.Element => {
  const {classes} = useCommon({
    withStyles: styles,
  });
  // const [isSelected, setIsSelected] = useState(true);

  const {onClick, ...restProps} = props;

  return (
    <Button
      className={classes.invisibleButton}
      onClick={() => {
        return;
        // setIsSelected(!isSelected);
        if (onClick) onClick({
          suit: restProps.suit, rank: restProps.rank,
        });
      }}
    >
      <div className={classNames(classes.cardContainer,
        //  isSelected && classes.insuranceSelected
         )}>
        <PokerInsurance {...restProps} hasNoGoldBorder isInitiallyFlipped cardSize='square'/>
      </div>
    </Button>
  );
};

export default InsurancePoker;
